import api from "@/utils/axios";

const REPORT_API_URL = `/reports`;

export default {
  namespaced: true,
  state: {
    reports: [],
    meta: {},
    loading: false,
    error: null,
  },
  mutations: {
    SET_REPORTS(state, data) {
      state.reports = data;
    },
    SET_META(state, meta) {
      state.meta = meta;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_REPORTS(state) {
      state.reports = [];
      state.meta = {};
      state.error = null;
    },
  },
  actions: {
    async fetchPaymentReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/payment/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Payment report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchSalesReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/sales/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Sales report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchTaxReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/tax/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Tax report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchDiscountReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(`${REPORT_API_URL}/discount/`, payload);
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Discount report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchProductPurchaseReport({ commit }, payload = {}) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(
          `${REPORT_API_URL}/product-purchase/`,
          payload
        );
        commit("SET_REPORTS", res.data.data);
        commit("SET_META", res.data.meta);
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || `Failed to fetch Product Purchase report`
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    clearReports({ commit }) {
      commit("CLEAR_REPORTS");
    },
  },
  getters: {
    reports: (state) => state.reports,
    reportMeta: (state) => state.meta,
    isReportLoading: (state) => state.loading,
    reportError: (state) => state.error,
  },
};
